import { Layout as PageLayout } from 'modules/app/components/templates/generic-page-layout/Layout';

export const AppError = () => {
  const displayTitle = 'Sorry, there was an error loading the app. Please try again later.';
  const displayMessage =
    "This doesn't mean we can't help you find a solution for your financial future.";

  return (
    <div className='error-layout '>
      <PageLayout title={displayTitle} subtitle={displayMessage} />
    </div>
  );
};
